class Logger {
  static isProduction = process.env.REACT_APP_BASE_URL.includes('bizedge');
  static log(...rest) {
    if (!this.isProduction) {
      console.log(rest);
    }
  }
  static error(...rest) {
    if (!this.isProduction) {
      console.error(rest);
    }
  }
  static warn(...rest) {
    if (!this.isProduction) {
      console.warn(rest);
    }
  }
  static info(...rest) {
    if (!this.isProduction) {
      console.info(rest);
    }
  }
}

export default Object.freeze(Logger);
